import {Component, Input} from '@angular/core';
import {TherapyPlanErrorFields} from '@drl/shared/models/csv-upload-report.model';

@Component({
  selector: 'app-therapy-plans-report',
  templateUrl: './therapy-plans-report.component.html',
  styleUrls: [],
})
export class TherapyPlansReportComponent {
  @Input() therapyPlansErrors: TherapyPlanErrorFields[];
}
